import { useTranslation } from "react-i18next";
import type { AppLanguageType } from "../config";
import { logI18nSetup } from "../init";
import type { LanguageStorage } from "../common/language-storage";

export const useChangeLanguage = (storage: LanguageStorage) => {
  const { i18n } = useTranslation();

  return (languageCode: AppLanguageType) => {
    i18n.changeLanguage(languageCode);
    storage.store(languageCode);
    logI18nSetup();
  };
};
